const backendDomain = 'https://backend.dealboxx.promo/api/'
const consumerDomain = "https://dealboxx.promo";

const Config = {
  backendDomain: backendDomain,
  consumerDomain,
  promoted:1,
  demoted:0,
}

export default Config